module.exports = __webpack_public_path__ + "img/marker_route_focused.dec86e41.svg";